import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import {
  EmailValidator,
  FindErrorItem,
  FindLoad,
  FindSuccessItem,
} from "utils";
import {
  authActions,
  httpRequestsOnErrorsActions,
  httpRequestsOnSuccessActions,
} from "store";
import { ButtonMain, InputMain } from "components";
import { Svg } from "assets";
import { CheckYourEmail } from "./checkYourEmail";

const ACTION_TYPE = "GET_RECOVERY_LINK";

export const ForgotModal = () => {
  const [showCheckEmail, toggleShowing] = useState(false);
  const { handleSubmit, control, setError, clearErrors, watch } = useForm({
    defaultValues: {
      email: "",
    },
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const success = FindSuccessItem(ACTION_TYPE);
  const backError = FindErrorItem(ACTION_TYPE);
  const loader = FindLoad(ACTION_TYPE);

  useEffect(() => {
    if (success) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
      toggleShowing(true);
    }
  }, [success]);

  useEffect(() => {
    return () => {
      dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
      clearErrors();
    };
  }, []);

  const getLink = (data) => {
    dispatch(authActions.getRecoveryLink(data?.email));
  };

  useEffect(() => {
    if (backError?.error === "User with this email was not found") {
      setError("email", {
        type: "required",
        message: "User with this email was not found",
      });
    }

    if (backError?.error === "User with this email was not found or in Inactive") {
      setError("email", {
        type: "required",
        message: "User with this email was not found or in Inactive",
      });
    }

    if (
        backError?.error ===
        "User Identification with this resource was not found."
    ) {
      setError("email", {
        type: "required",
        message: "User with this email was not found.",
      });
    }

  }, [backError]);

  return (
    <div className="login-wrapper">
      <div className="login-box">
        {showCheckEmail ? (
          <CheckYourEmail
            email={watch("email")}
            toggleShowing={toggleShowing}
          />
        ) : (
          <>
            <Svg.ForgotSvg className="login-main-svg" />

            <h3 className="login-title">Forgot your Password?</h3>

            <p className="login-description">
              Enter your email address and we'll send you a recovery email to
              reset your password.
            </p>

            <form className="login-form" onSubmit={handleSubmit(getLink)}>
              <InputMain
                variant="outlined"
                name="email"
                control={control}
                placeholder="Enter your email address"
                labelHeader="Email Address"
                rules={{
                  required: "Input is not field",
                  pattern: {
                    value: EmailValidator,
                    message: "Invalid Email Format",
                  },
                }}
                startAdornment={<Svg.SmsSvg />}
              />

              <div className="login-buttons-block">
                <ButtonMain
                  type="submit"
                  load={!!loader?.length}
                  width={"100%"}
                  text={"Get Reset Link"}
                />

                <ButtonMain
                  type="button"
                  width={"100%"}
                  text={"Cancel"}
                  cancel
                  onClick={() => {
                    navigate("/login");
                  }}
                />
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};
